import { useContext, useEffect, useRef } from 'react'
import { toast } from 'react-hot-toast'
import { useAppSelector } from '@state/hooks'
import { selectLastFreshAt } from '@state/slices/oracleSlice'
import { TabNavigationContext } from '@contexts/TabNavigationContext'

const SUPPRESSION_WINDOW_MS = 5000
const TOAST_COPY = 'Switched to Causal Insights — see how Causeway reasoned'

function useCausalInsightsAutoSwitch() {
  const ctx = useContext(TabNavigationContext)
  const lastFreshAt = useAppSelector(selectLastFreshAt)
  const lastSeenRef = useRef<number | null>(null)

  useEffect(() => {
    if (!ctx) return
    if (lastFreshAt == null) return
    if (lastSeenRef.current === lastFreshAt) return // already handled

    lastSeenRef.current = lastFreshAt

    // Suppression: user navigated tabs in the last 5s — don't yank them.
    const recent =
      ctx.lastUserTabChangeAt != null &&
      Date.now() - ctx.lastUserTabChangeAt < SUPPRESSION_WINDOW_MS
    if (recent) return

    ctx.navigateToTabSilent('oracle')
    toast.success(TOAST_COPY, { duration: 4000 })
  }, [lastFreshAt, ctx])
}

export default useCausalInsightsAutoSwitch
